import EvStationIcon from '@mui/icons-material/EvStation';
import React from 'react';
import { uid } from 'react-uid';
import { ChargePoint, UserOrganisation } from '../../../../../../app/ApiGen';
import { ChargePointAvatar } from '../../../../../../components/Avatar/ChargePoint';
import { ContainerHeader, HeaderSection, Item, MenuSection, Separator } from '../../../../../../design-system';
import { getChargePointImage } from '../../../../../../utils/chargePoints/getChargePointImage';
import { Normalised } from '../../../../../../utils/request';
import { useMenuItemsFactory } from './menuItems';

type MenuProps = {
  chargePoint: Normalised<ChargePoint>;
  organisation: UserOrganisation;
};

export const Menu: React.FC<MenuProps> = ({ chargePoint, organisation }) => {
  const { vendor, model } = chargePoint;
  const menuItems = useMenuItemsFactory({ chargePoint, organisation });

  return (
    <>
      <HeaderSection>
        {() => (
          <ContainerHeader
            avatar={
              <ChargePointAvatar src={vendor && model ? getChargePointImage(vendor, model) : undefined}>
                <EvStationIcon />
              </ChargePointAvatar>
            }
            text={chargePoint.name}
            subText="Charge point"
          />
        )}
      </HeaderSection>
      <Separator mb={1} />
      <MenuSection canOverflow>
        {() =>
          menuItems.map((menuItem, idx) =>
            menuItem.shouldRender ? <Item key={uid(idx)} text={menuItem.text} to={menuItem.path} /> : <></>,
          )
        }
      </MenuSection>
    </>
  );
};
